import type { ethers } from 'ethers'

const CONTRACT_ADDRESS: string = '0x3fb3d199Fc5768ed1c5Cc86540c2384fd5970986'
const INFURA_ID: string = '16cfba5220e54dd6aa3720e93366951a'
const CHAIN_ID = 1

function setupTokenMintedPromise(
  contract: ethers.Contract,
  callback: (remaining: number, total: number) => void,
) {
  Promise.all([contract.totalSupply(), contract.maxSupply()]).then(
    (data) => {
      callback(data[0], data[1])
    },
    (reason: any) => {
      console.log('error in index count ' + reason)
    },
  )
}

function getRefererCode(): string {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  return urlParams.get('promo') || ''
}

export {
  getRefererCode,
  setupTokenMintedPromise,
  CONTRACT_ADDRESS,
  INFURA_ID,
  CHAIN_ID,
}
